'use strict';

export default function($stateProvider, privateDocConfig) {
  'ngInject';
  $stateProvider
    .state('privateDocumentation', {
      abstract: true,
      url: '/documentation',
      template: '<privatedocumentation></privatedocumentation>'
    })
    .state('privateDocumentation.landing', {
      url: '/landing',
      template: require('../static/landing.html')
    });
    
    privateDocConfig.privateDocumentation.forEach(article => {
      $stateProvider.state(`privateDocumentation.${article.name}`, {
        url: `/${article.name}`,
        template: require(`../static/${article.filename}`)
      });
    });
}    



// WEBPACK FOOTER //
// ./client/app/documentation/private/privateDocumentation.routes.js